import $ from 'jquery'

function refreshBatchRecap($board) {
  const totals = { venues: 0, sesi1: 0, sesi2: 0, total: 0 }

  $board.find('.batch-column').each(function () {
    const batch = $(this).attr('data-batch') || ''
    let venues = 0
    let sesi1 = 0
    let sesi2 = 0

    $(this).find('.batch-venue-card').each(function () {
      venues += 1
      sesi1 += parseInt($(this).attr('data-sesi-1'), 10) || 0
      sesi2 += parseInt($(this).attr('data-sesi-2'), 10) || 0
    })

    const rowTotal = sesi1 + sesi2
    const $row = $(`#batch-recap-table tr[data-recap-batch="${batch}"]`)
    $row.find('.js-recap-venues').text(venues)
    $row.find('.js-recap-sesi-1').text(sesi1)
    $row.find('.js-recap-sesi-2').text(sesi2)
    $row.find('.js-recap-total').text(rowTotal)
    $(this).find('.js-column-count').text(venues)

    totals.venues += venues
    totals.sesi1 += sesi1
    totals.sesi2 += sesi2
    totals.total += rowTotal
  })

  $('.js-recap-all-venues').text(totals.venues)
  $('.js-recap-all-sesi-1').text(totals.sesi1)
  $('.js-recap-all-sesi-2').text(totals.sesi2)
  $('.js-recap-all-total').text(totals.total)
}

function findDropzone(el) {
  return $(el).closest('.batch-column').find('.batch-dropzone').get(0)
}

function initBatchBoard() {
  const board = document.getElementById('batch-board')
  if (!board || board.dataset.dndReady === '1') return
  board.dataset.dndReady = '1'

  const $board = $(board)
  let draggedCard = null

  board.addEventListener('dragstart', function (e) {
    const card = e.target.closest('.batch-venue-card')
    if (!card || !board.contains(card)) return
    draggedCard = card
    card.classList.add('is-dragging')
    e.dataTransfer.effectAllowed = 'move'
    e.dataTransfer.setData('text/plain', card.getAttribute('data-venue-id') || '')
  })

  board.addEventListener('dragend', function (e) {
    const card = e.target.closest('.batch-venue-card')
    if (card) card.classList.remove('is-dragging')
    board.querySelectorAll('.batch-dropzone.is-dragover').forEach(function (zone) {
      zone.classList.remove('is-dragover')
    })
    draggedCard = null
  })

  // dragover harus preventDefault agar browser mengizinkan drop
  board.addEventListener('dragover', function (e) {
    const zone = findDropzone(e.target)
    if (!zone) return
    e.preventDefault()
    e.dataTransfer.dropEffect = 'move'
    board.querySelectorAll('.batch-dropzone.is-dragover').forEach(function (z) {
      if (z !== zone) z.classList.remove('is-dragover')
    })
    zone.classList.add('is-dragover')
  })

  board.addEventListener('dragleave', function (e) {
    const zone = e.target.closest('.batch-dropzone')
    if (!zone || !board.contains(zone)) return
    if (zone.contains(e.relatedTarget)) return
    zone.classList.remove('is-dragover')
  })

  board.addEventListener('drop', function (e) {
    const zone = findDropzone(e.target)
    if (!zone) return
    e.preventDefault()
    e.stopPropagation()
    zone.classList.remove('is-dragover')

    if (!draggedCard) {
      const id = e.dataTransfer.getData('text/plain')
      draggedCard = id ? board.querySelector('.batch-venue-card[data-venue-id="' + id + '"]') : null
    }
    if (!draggedCard) return

    const batch = zone.getAttribute('data-batch') || ''
    zone.appendChild(draggedCard)
    const input = draggedCard.querySelector('.js-venue-batch')
    if (input) input.value = batch
    draggedCard.classList.remove('is-dragging')
    refreshBatchRecap($board)
  })
}

$(initBatchBoard)
export { initBatchBoard }
